import { render, staticRenderFns } from "./problemOne.vue?vue&type=template&id=5061995e&scoped=true"
import script from "./problemOne.vue?vue&type=script&lang=js"
export * from "./problemOne.vue?vue&type=script&lang=js"
import style0 from "./problemOne.vue?vue&type=style&index=0&id=5061995e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061995e",
  null
  
)

export default component.exports